import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { apiResponseFactory } from 'src/app/models/response/apiResponseFactory';
import { KantoniDto } from '../models/kantoni.model';
import { PagedResponse } from '../models/paged-response.model';
import { BaseApiService } from './base-api.service';

@Injectable({
  providedIn: 'root'
})
export class KantoniService {
  constructor(private api: BaseApiService) { }

  getAll(params: any = {}): Observable<KantoniDto[]> {
    return this.api.get('kantoni/all', params).pipe(
      map((response: HttpResponse<apiResponseFactory>) => {
        if (response.status == 200 && response?.body?.result) {
          return response.body.result.map((city) => new KantoniDto(city));
        }
        return undefined;
      }),
      catchError(this.handleError<KantoniDto[]>(`kantoni/all`))
    );
  }

  getPaged(params: any): Observable<PagedResponse<KantoniDto>> {
    return this.api.post('kantoni', params).pipe(
      map((response) => {
        const pagedModel = new PagedResponse<KantoniDto>(
          response.body.result
        );
        pagedModel.items = pagedModel.items?.map((i) => new KantoniDto(i));
        return pagedModel;
      })
    );
  }

  getById(params: any): Observable<any> {
    return this.api
      .post('kantoni/by-id', params)
      .pipe(catchError(this.handleError<[]>(`kantoni/by-id`)));
  }

  update(params: any = {}): Observable<any> {
    return this.api
      .post('kantoni/update', params)
      .pipe(catchError(this.handleError<[]>('kantoni/update')));
  }

  create(params: any = {}): Observable<any> {
    return this.api
      .post('kantoni/create', params)
      .pipe(catchError(this.handleError<[]>('kantoni/create')));
  }

  delete(params: any): Observable<any> {
    return this.api
      .post('kantoni/delete', params)
      .pipe(catchError(this.handleError<[]>('kantoni/delete')));
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      const errorMsg = `${operation} failed: ${error.message}`;

      return throwError(error);
    };
  }
}
